import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=92709556&"
import script from "./IncomingCall.vue?vue&type=script&lang=js&"
export * from "./IncomingCall.vue?vue&type=script&lang=js&"
import style0 from "./IncomingCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports